import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import { BackgroundVariant } from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Image = styled.img `
  ${imageCoverContainer()};
`;
const ImageWrapper = styled.div `
  ${imageWrapperPreserveRatio(64, 64)};

  overflow: visible;

  ${Image} {
    border-radius: 5000px;
    width: calc(100% - 12px);
    height: auto;
    aspect-ratio: 1;
    left: auto;
    right: 0;

    @media ${until(Device.TabletLarge)} {
      display: none;
    }
  }
`;
const Container = styled.blockquote `
  display: grid;
  grid-template-columns: ${fluid(40, 64)} 1fr;
  gap: ${fluid(16, 24)};
  padding: ${fluid(24, 40)} ${fluid(16, 28)};
  border: 1px solid ${brand.global.white};
  border-radius: ${fluid(16, 24)};
  background-color: var(--bgColour);
  color: var(--fgColour);
  height: 100%;

  &[data-variant=${BackgroundVariant.Blue}] {
    --bgColour: ${brand.primary.blue.dark};
    --fgColour: ${brand.global.white};
  }

  &[data-variant=${BackgroundVariant.White}] {
    --bgColour: ${brand.global.white};
    --fgColour: ${brand.global.black};
  }

  &:has(${ImageWrapper} > ${Image}) {
    grid-template-columns: ${fluid(40, 128)} 1fr;
  }
`;
const Icon = styled.div `
  display: grid;
  place-content: center;
  background-color: ${brand.primary.blue.light};
  color: ${brand.global.white};
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  aspect-ratio: 1;
  border-radius: 5000px;

  svg {
    width: ${fluid(20, 36)};
  }

  @media ${from(Device.TabletLarge)} {
    ${ImageWrapper}:has(${Image}) & {
      width: ${fluid(58, 64)};
      top: auto;
      bottom: calc(${fluid(16, 24)} * -1);

      svg {
        width: ${fluid(36, 40)};
      }
    }
  }
`;
const ContentWrapper = styled.div `
  display: flex;
  flex-direction: column;
`;
const CompanyLogo = styled.div `
  position: relative;
  height: ${fluid(26, 32)};
  margin-bottom: 16px;

  ${Image} {
    object-position: left;
    object-fit: contain;
  }

  &[data-portrait='true'] {
    height: ${fluid(52, 64)};
  }
`;
const Quote = styled.p `
  ${fonts.lato.regular};

  font-size: ${fluid(14, 16)};
  line-height: ${fluid(22, 30)};

  ${ContentWrapper}:has(footer) & {
    margin-bottom: 30px;

    @media ${from(Device.TabletLarge)} {
      margin-bottom: ${fluid(20, 24)};
    }
  }
`;
const Quotee = styled.footer `
  ${fonts.intro};

  margin-top: auto;
  font-size: ${fluid(14, 16)};
  line-height: ${fluid(20, 24)};
`;
const JobTitle = styled.cite `
  display: block;
  font-weight: 400;
  font-style: normal;
`;
const TestimonialCardStyles = {
    Container,
    ImageWrapper,
    Image,
    Quote,
    Icon,
    CompanyLogo,
    Quotee,
    ContentWrapper,
    JobTitle,
};
export default TestimonialCardStyles;
